import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { TokenHandlerService } from './shared/token-handler.service';
import { tap, delay, catchError } from 'rxjs/operators';
import { AuthInfo, CoreResponse, loginInfo, User } from '../model/shared/model';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from './shared/local-storage.service';
import { AuthenticationService } from './shared/authentication.service';
import { EnvService } from '../shared/environment-service/env.service';

//import { LocalStorageService } from "./local-storage.service";
//import { AuthInfo, Branch, CareNetAPIResponse, Company, CoreResponse, CustomerSubscription, CustomResponse, FavItems, SessionInfo, SystemMenus, User } from '..model/';

@Injectable({
  providedIn: 'root'
})
export class LoginService {


  tokenSubject!: BehaviorSubject<string | null>;
  public token!: Observable<string | null>;

  userNameSubject!: BehaviorSubject<string | null>;
  public username!: Observable<string | null>;

  private environment;
  private url;

  isAuthorized: boolean;
  authMessage: string;
  loginInfo: loginInfo = new loginInfo();
  isUserLogin: boolean;

  private httpHeaders = new HttpHeaders()
    //.set('Access-Control-Allow-Headers','Origin, X-Requested-With, Content-Type, Accept, Authorization')
    .set('Authorization', 'bearer ' + localStorage.getItem("MedlUToken"))

  private _httpHeaders = new HttpHeaders().set('Accept', 'application/json').set('Cache-Enabled', 'true').set('Accept', '*/*').set('content-type', 'application/json').set('Access-Control-Allow-Headers', "Origin, X-Requested-With, Content-Type, Accept, Authorization");

  constructor(private router: Router, private httpClient: HttpClient,
    public localStorageService: LocalStorageService,
    private tokenhandler: TokenHandlerService,
    private auth: AuthenticationService,
    public env: EnvService) {
    //this.environment = environment;
    this.url = this.env.Environment.carenetApiUrl;


  }



  forgotPassword(username: string) {
    return this.httpClient.get<any>(`${this.url}/api/member/ForgotPassword?email=${username}`, { headers: this.httpHeaders })

  }

  ChangePassword(memberEmail: string, newPassword: string): Observable<any> {
    let data = {
      'memberEmail': memberEmail,
      'newPassword': newPassword,
    };
    let _httpHeaders = new HttpHeaders()

      .set('Authorization', 'bearer ' + localStorage.getItem("MedlUToken"))

    //For HTTPPost
    const url = `${this.url}/api/member/ChangePassword`;
    //const url = `http://localhost:3333/api/member/ChangePassword`;
    return this.httpClient.post(url, data, { headers: _httpHeaders });
  }

  public get currentTokenSubjectValue(): string | null {
    return this.tokenSubject.value;
  }


  async AuthorizedLogin(loginInfo) {

    //return new Promise(resolve => {
    let jData = JSON.stringify(loginInfo);

    let getUrl = this.url + "api/Security/ReferralPortalLogin";
    var use_main_db = "false";
    if (this.env.Keys.cloudManagerEnabled) {
      use_main_db = "false";
    } else {
      use_main_db = "true";
    }


    const options = { headers: { 'Content-Type': 'application/json', 'use_main_db': use_main_db, } };
    return this.httpClient.post(getUrl, jData, options).toPromise().then((
      async (json: Object) => {

        let authInfo = new CoreResponse<AuthInfo>().fromJSON(json).content;
        let coreResponse = new CoreResponse().fromJSON(json);

        if (coreResponse && coreResponse.isError && coreResponse.message) {
          this.isAuthorized = false;
          this.authMessage = coreResponse.message;
        }
        else if (authInfo && authInfo.authMessage) {
          this.isAuthorized = false;
          this.authMessage = authInfo.authMessage;
        }
        else if (coreResponse.isUserLogin) {
          this.isAuthorized = true;
          this.isUserLogin = true;
        }
        else {
          let user = new User();
          user.Username = loginInfo.Username;
          user.Password = loginInfo.Password;
          user.BranchId = authInfo.branchId;
          user.CompanyId = authInfo.companyId;
          user.language = loginInfo.language;
          // user.labId = user.loggedLabId;
          //  user.payerFullName = user.loggedPayerFullName;
          //  user.payerId = user.loggedPayerId;
          //  user.payerPricelistId = user.loggedPayerPricelistId;
          //  user.providerId = user.loggedProviderId;
          // user.processingLabId = user.processingLabId;
          // user.referralLabId = user.referralLabId;


          this.auth.setToken(authInfo.token);
          this.auth.setTokenExpiredate(authInfo.timeout);
          this.auth.setSessionId(authInfo.sessionId);
          this.auth.setLoggedInUser(user);
          this.auth.setloggedInSettings(coreResponse);
          this.isAuthorized = true;
          this.authMessage = null;

          this.router.navigateByUrl('/ordersmanagement/lab-orders');
        }

      }));
    //});
  }

  UpdatePasswod(oldPassword, newPassword, confirmPassword, userName): Observable<any> {
    let data = {
      'oldPassword': oldPassword,
      'newPassword': newPassword,
      'confirmPassword': confirmPassword,
      'username': userName
    };

    //For HTTPPost
    const url = this.url + 'api/Security/ChangePassword';
    const options = { headers: { 'Content-Type': 'application/json', 'use_main_db': 'true', } };
    return this.httpClient.post(url, data, options);
  }

  setLoggedInUser(user) {
    this.localStorageService.SetItem('loggedInUser', JSON.stringify(user));
  }

  getLoggedInUser() {
    if (this.localStorageService.GetItem('loggedInUser')) {
      return (this.localStorageService.GetItem('loggedInUser') ? (JSON.parse(this.localStorageService.GetItem('loggedInUser'))) : null);
    }
    else {
      //this.logout();
      return null;
    }
  }




}



